import { type TcsChallanEvent } from '@utazzo/shared';
import React from 'react';

import { formatLocalDMY } from '@/lib/date-format';

/** Audit timeline of a challan: what happened, by whom, when (events arrive newest first). */
export const TcsChallanTimeline = ({ events }: { events: TcsChallanEvent[] }): React.JSX.Element =>
  events.length === 0 ? (
    <p className="text-sm text-zinc-500">No activity yet.</p>
  ) : (
    <ol className="space-y-2" aria-label="Audit timeline">
      {events.map((e) => (
        <li key={e.id} className="rounded-md border border-zinc-100 px-3 py-2">
          <p className="text-sm text-zinc-800">{e.summary}</p>
          <p className="text-xs text-zinc-500">
            {e.actorName ?? 'System'} - {formatLocalDMY(e.createdAt)}
          </p>
        </li>
      ))}
    </ol>
  );
